import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Inject,
} from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { User } from "../../../models/user";
import { CompanyLinked } from "../../../models/companylinked";
import { NuevoCompany } from "../../../tables/listcompany/listcompany.component";
import { Router, ActivatedRoute } from "@angular/router";
import { FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { CitaService } from "../../../services/cita.service";
import { UserService } from "../../../services/user.service";
import { ScrapService } from "../../../services/scrap.service";
import { CompanylinkedService } from "../../../services/companylinked.service";
import { POService } from "../../../services/po.service";
import { CategoriesService } from "../../../services/categories.service";
import { FolderService } from "../../../services/folder.service";
import { Folder } from "../../../models/folder";
import swal from "sweetalert2";
import { map, startWith } from "rxjs/operators";
import { LocationService } from "../../../services/location.service";
import { Methods } from "../../../shared/methods";

import { TaxService } from "../../../services/tax.service";
export interface UserList {
  value: string;
  name: string;
}

@Component({
  selector: "app-filter",
  templateUrl: "./filter.component.html",
  styleUrls: ["./filter.component.css"],
  providers: [
    UserService,
    POService,
    CitaService,
    CompanylinkedService,
    ScrapService,
    CategoriesService,
    FolderService,
  ],
})
export class FilterComponent implements OnInit {
  @Input() type = "VENDOR";
  @Input() plholder = "";
  @Input() label = "";
  @Input() sync = false;
  @Input() so = null;
  @Output() select: EventEmitter<any>;

  public mtds: Methods = new Methods();

  public user;
  public status_user;
  sexos = [
    { value: "1", viewValue: "Male" },
    { value: "0", viewValue: "Female" },
  ];

  // public plholder = 'Client Name or Company Name';

  public loading = false;

  filteredOptions: Observable<string[]>;
  public filteredClientes: Observable<UserList[]>;
  public myControlClientes = new FormControl();
  public poList: any[] = [];
  public syncpos = false;
  public token;
  public clientSelected = "";
  public formnewpacient = false;
  public pacientes;
  clientes: UserList[] = [];

  public nuevoCliente: UserList = {
    value: "newClient",
    name: "New Customer",
  };

  constructor(
    public dialog: MatDialog,
    private _companylinkedService: CompanylinkedService,
    private _scrapService: ScrapService,
    private _userService: UserService,
    private _poService: POService,
    private _citaService: CitaService,
    private _router: Router,
    private _folderService: FolderService,
    private _cattegorieServices: CategoriesService
  ) {
    this.select = new EventEmitter();
    this.token = this._userService.getToken();
  }

  ngOnInit() {
    console.log("holaaqi");
    if (this.type === "COMPANY") {
      this.plholder = "Company Name";
    } else if (this.type === "SCRAP") {
      this.plholder = "Select Scrap";
    }

    this.filteredClientes = this.myControlClientes.valueChanges.pipe(
      startWith<string | UserList>(""),
      map((value) => (typeof value === "string" ? value : value.name)),
      map((name) => (name ? this._filterClientes(name) : this.clientes.slice()))
    );
    if (this.type === "SCRAP") {
      this.loading = true;
      this._scrapService.getAll(this.token, "CLOSED").subscribe(
        (response) => {
          console.log(response);
          if (response.status === "success") {
            this.pacientes = response.data;

            response.data.forEach(
              function (element) {
                if (element.companyLinked === null) {
                } else {
                  this.clientes.push({
                    value: element.id,
                    name:
                      element.id +
                      " - " +
                      element.categoryId.name +
                      " - " +
                      (Number(element.grossWeight) -
                        Number(element.tareWeight)) +
                      " lbs",
                  });
                }
              }.bind(this)
            );
          }
          this.loading = false;
        },
        (error) => {
          console.log(<any>error);
          this.loading = false;
        }
      );
    } else if (this.type === "COMPANY") {
      this.loading = true;
      this._companylinkedService
        .getAllCompaniesLite(this.token, "all")
        .subscribe(
          (response) => {
            console.log(response);
            if (response.status === "success") {
              this.pacientes = response.data;

              response.data.forEach(
                function (element) {
                  if (element.companyLinked === null) {
                  } else {
                    this.clientes.push({
                      value: element.id,
                      name: element.name,
                    });
                  }
                }.bind(this)
              );
            }
            this.loading = false;
          },
          (error) => {
            console.log(<any>error);
            this.loading = false;
          }
        );
    } else if (this.type === "alllistforsell") {
      this.loading = true;
      this._userService.getAllUsersForSO(this.token, this.so).subscribe(
        (response) => {
          if (response.status === "success") {
            this.pacientes = response.data;

            response.data.forEach(
              function (element) {
                if (element.companyLinked === null) {
                } else {
                  this.clientes.push({
                    value: element.id,
                    name:
                      element.name +
                      " " +
                      element.surname +
                      " # " +
                      element.id +
                      " - " +
                      element.company,
                  });
                }
              }.bind(this)
            );
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.mtds.notifyError(error.statusText, error.status);
          console.log(<any>error);
        }
      );
    } else if (this.type === "alllistforpurchase") {
      this.loading = true;
      this._userService.getAllUsersForPO(this.token, this.so).subscribe(
        (response) => {
          console.log(response);
          if (response.status === "success") {
            this.pacientes = response.data;

            response.data.forEach(
              function (element) {
                if (element.companyLinked === null) {
                } else {
                  this.clientes.push({
                    value: element.id,
                    name:
                      element.name +
                      " " +
                      element.surname +
                      " # " +
                      element.id +
                      " - " +
                      element.company,
                  });
                }
              }.bind(this)
            );
          } else {
            // localStorage.clear();
            // this._router.navigate(['/pages/lock']);
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.mtds.notifyError(error.statusText, error.status);
          console.log(<any>error);
        }
      );
    } else {
      this.loading = true;
      this._userService.getAllUsersType(this.token, this.type).subscribe(
        (response) => {
          if (response.status === "success") {
            this.pacientes = response.data;

            response.data.forEach(
              function (element) {
                if (element.companyLinked === null) {
                } else {
                  this.clientes.push({
                    value: element.id,
                    name:
                      element.name +
                      " " +
                      element.surname +
                      " # " +
                      element.id +
                      " - " +
                      element.companyLinked.name,
                  });
                }
              }.bind(this)
            );
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.mtds.notifyError(error.statusText, error.status);
          console.log(<any>error);
        }
      );
    }
  }

  private _filterClientes(name: string): UserList[] {
    const filterValue = name.toLowerCase();
    return this.clientes.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  displayFn(user?: UserList): string | undefined {
    return user ? user.name : undefined;
  }

  syncCompanies() {
    this.syncpos = true;
    this._citaService.syncCompanies().subscribe(
      (response) => {
        let response_1: any = response;
        if (response_1.status === 200) {
          this._userService.getAllUsersType(this.token, "VENDOR").subscribe(
            (response2) => {
              let response_2: any = response2;
              if (response_2.status === "success") {
                this.pacientes = response_2.data;
                this.syncpos = false;
                response_2.data.forEach(
                  function (element) {
                    console.log(element);
                    if (element.companyLinked === null) {
                    } else {
                      this.clientes.push({
                        value: element.id,
                        name:
                          element.name +
                          " " +
                          element.surname +
                          " # " +
                          element.id +
                          " - " +
                          element.companyLinked.name,
                      });
                    }
                  }.bind(this)
                );
              } else {
                localStorage.clear();
                this._router.navigate(["/pages/lock"]);
              }
            },
            (error) => {
              this.mtds.notifyError(error.statusText, error.status);
              console.log(<any>error);
            }
          );

          this.syncpos = false;
        }
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        console.log(<any>error);
      }
    );
  }

  syncpolist() {
    this.syncpos = true;
    this._poService.syncpos(this.token).subscribe(
      (response) => {
        if (response.status === "success") {
          this._poService
            .getAllPOsLiteByUser(this.token, this.clientSelected)
            .subscribe(
              (response2) => {
                console.log(response2);
                if (response2.status === "success") {
                  this.poList = response2.data;
                  this.syncpos = false;
                }
              },
              (error) => {
                console.log(<any>error);
                // this.mtds.notifyError(error.statusText, error.status);
              }
            );
        }
      },
      (error) => {
        console.log(<any>error);
        // this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  OnHumanSelected(option) {
    console.log(option);
    if (option.value.value === "newClient") {
      this.agregarCliente();
    } else if (this.type === "SCRAP") {
      let item;
      for (item of this.pacientes) {
        if (option.value.value === item.id) {
          this.select.emit(item);
          break;
        }
      }
    } else if (this.type === "COMPANY") {
      this.select.emit(option.value);
    } else {
      let idclient = option.value.value;
      if (this.clientSelected === "NOPACIENTE") {
        this.formnewpacient = true;
      } else {
        this._userService.getUser(this.token, idclient).subscribe(
          (response) => {
            console.log(response);
            if (response.status === "success") {
              this.select.emit(response.data);
            }
          },
          (error) => {
            console.log(<any>error);
          }
        );
      }
    }
  }

  agregarCliente(): void {
    this.user = new User(
      1,
      "customer",
      "",
      "",
      "",
      "demo123",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      0,
      "",
      1,
      1,
      1,
      "",
      0,
      "",
      "",
      "",
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      "",
      "",
      "",
      ""
    );
    let dialogRef = this.dialog.open(NuevoPaciente, {
      width: "80%",
      data: { user: this.user, sexos: this.sexos },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("Respuesta");
      console.log(result);

      this._userService.create(this.token, result.usuario).subscribe(
        (response) => {
          console.log(response);
          this.status_user = response.status;

          if (this.status_user !== "success") {
            this.status_user = "error";
            if (response.code === 400) {
              alert(
                "It was not possible to add the user because: " + response.msg
              );
            } else {
              alert(
                "Error! Something went wrong, it was not possible to add the user"
              );
            }
          } else {
            let categories = {
              user_id: response.user.id,
              category_id: JSON.stringify(result.categories),
            };
            console.log(categories);
            this._cattegorieServices.linkUserCategories(categories).subscribe(
              (respuesta) => {
                if (respuesta.status === "success") {
                  console.log("Categorias Agregadas Exitosamente!");
                } else {
                  console.log("Error al cargar categorias!");
                }
              },
              (error) => {
                console.log("Error al cargar categorias!");
              }
            );
            let userid = {
              name: "mad",
              value: response.user.id,
            };

            if (response.hasfolder == null) {
              let folderNEw = new Folder(
                1,
                response.user.companyLinked.name,
                "",
                "",
                userid,
                "",
                0,
                0,
                1,
                0
              );
              console.log(folderNEw);
              this._folderService.create(this.token, folderNEw).subscribe(
                (response) => {
                  console.log(response);
                  this.status_user = response.status;

                  if (this.status_user !== "success") {
                    // this.status_user = 'error';
                  } else {
                    // this.showSwal('success-message');
                    console.log("folder created");
                  }
                },
                (error) => {
                  console.log(<any>error);
                }
              );
            }

            swal.fire({
              title: "Customer successfully added!",
              text: "",
              buttonsStyling: false,
              customClass: {
                confirmButton: "btn btn-success",
              },
            });

            this.clientes.push({
              value: response.user.id,
              name:
                response.user.name +
                " " +
                response.user.surname +
                " # " +
                response.user.id +
                " - " +
                response.user.companyLinked.name,
            });

            this.clientSelected =
              response.user.name +
              " " +
              response.user.surname +
              " # " +
              response.user.id +
              " - " +
              response.user.companyLinked.name;
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    });
  }
}

@Component({
  selector: "registro-paciente",
  templateUrl: "../../../customers/nuevo-cliente/nuevo-cliente.component.html",
  styleUrls: ["../../../customers/nuevo-cliente/nuevo-cliente.component.css"],
  providers: [UserService, CompanylinkedService, CategoriesService],
})
export class NuevoPaciente {
  public identity;
  public token;
  public user: User;
  public status_user;
  public privilegio;
  public companySelected = "";
  public companies;
  public company;
  public allCategories;
  public categories: any[] = [];
  public userCategories: number[] = [];
  public companyLinked = null;
  public companyLocations: any[] = [];
  public countries;
  public states = [];
  public country_id;
  public loadingReps = false;
  public repsList: any[] = [];

  filteredCountries: Observable<UserList[]>;
  filteredStates: Observable<UserList[]>;
  myControlCountries = new FormControl();
  myControlStates = new FormControl();
  private _filterCountries(name: string): UserList[] {
    const filterValue = name;

    return this.countries.filter((option) =>
      String(option.name).toLowerCase().startsWith(filterValue)
    );
  }

  private _filterStates(name: string): UserList[] {
    const filterValue = name;

    return this.states?.filter((option) =>
      String(option.name).toLowerCase().startsWith(filterValue)
    );
  }
  sexos = [
    { value: "1", viewValue: "Male" },
    { value: "0", viewValue: "Female" },
  ];

  frequencies = [
    { value: "DAILY", viewValue: "Daily" },
    { value: "WEEKLY", viewValue: "Weekly" },
    { value: "MONTHLY", viewValue: "Monthly" },
    { value: "NEVER", viewValue: "Never" },
  ];

  cities = [
    { value: "paris-0", viewValue: "Paris" },
    { value: "miami-1", viewValue: "Miami" },
    { value: "bucharest-2", viewValue: "Bucharest" },
    { value: "new-york-3", viewValue: "New York" },
    { value: "london-4", viewValue: "London" },
    { value: "barcelona-5", viewValue: "Barcelona" },
    { value: "moscow-6", viewValue: "Moscow" },
  ];

  public mtds: Methods = new Methods();
  public companyName = "";

  constructor(
    public dialogRef: MatDialogRef<NuevoPaciente>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _userService: UserService,
    private _companylinkedService: CompanylinkedService,
    private _route: ActivatedRoute,
    private _locationService: LocationService,
    private _router: Router,
    public dialog: MatDialog,
    private _cattegorieServices: CategoriesService,
    private _taxService: TaxService
  ) {
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    data.user.user_id = this.identity.sub;

    this.token = this._userService.getToken();
    this.getAllCompanies();
    this.getCategories();
    this.getReps();
  }
  getReps() {
    this.loadingReps = true;
    this._userService.getAllReps(this.token).subscribe((r) => {
      this.repsList = r.data.map((e) => {
        return { id: e.id, name: `${e.name} ${e.surname}` };
      });
      // this.repsList.push({id: 4, name: 'Admin Admin'});
      // console.log(this.repsList);
      this.loadingReps = false;
    });
  }
  validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
  public buscandoCompanies = false;
  getAllCompanies() {
    this.buscandoCompanies = true;
    this._companylinkedService.getAllCompaniesLite(this.token, "all").subscribe(
      (response) => {
        console.log(response);
        if (response.status === "success") {
          this.companies = response.data;
          console.log(this.companies);
        } else {
          this.mtds.notifyError(response.msg, response.code);
        }
        this.buscandoCompanies = false;
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        console.log(<any>error);
        this.buscandoCompanies = false;
      }
    );
  }
  get isDisabledFirstStep(): boolean {
    return (
      !this.data.user.name || !this.data.user.surname || !this.data.user.email
    );
  }
  // get completedFirstStep(): boolean {
  //   return this.data.user.companyId && this.data.user.name;
  // }
  get isDisabledSecondStep(): boolean {
    return (
      !this.data.user.address ||
      !this.data.user.country ||
      !this.data.user.colonia ||
      !this.data.user.city ||
      !this.data.user.zipCode ||
      !this.data.user.phone
    );
  }
  get isDisabledThirdStep(): boolean {
    return (
      !this.data.user.address ||
      !this.data.user.country ||
      !this.data.user.colonia ||
      !this.data.user.city ||
      !this.data.user.zipCode ||
      !this.data.user.phone
    );
  }
  getCategories() {
    this._cattegorieServices.showAll().subscribe(
      (response) => {
        if (response.status === "success") {
          this.allCategories = response.data;
          for (let item of response.data) {
            if (item.father === 0) {
              let padre = {
                id: item.id,
                father: item.father,
                name: item.name,
                sub: [],
              };
              this.categories.push(padre);
            }
          }

          for (let item of response.data) {
            if (item.father !== 0) {
              let hijo = {
                id: item.id,
                father: item.father,
                name: item.name,
              };
              for (let i of this.categories) {
                if (i.id === hijo.father) {
                  i.sub.push(hijo);
                  break;
                }
              }
            }
          }
          // console.log('Aquie merengues');
          // console.log(this.categories);
        } else {
          console.log("Error!");
        }
      },
      (error) => {
        console.log("Error!");
      }
    );
  }

  addCategoire(category, evento) {
    if (category.name !== "All") {
      if (!evento.checked) {
        let index = 0;
        for (let item of this.userCategories) {
          if (item === category.id) {
            this.userCategories.splice(index, 1);
          }
          index++;
        }
        console.log(category.father);
        if (category.father === 0) {
          for (let itemCat of this.allCategories) {
            if (this.isAdded(itemCat.id) && itemCat.father === category.id) {
              let index = 0;
              for (let i of this.userCategories) {
                if (itemCat.id === i) {
                  this.userCategories.splice(index, 1);
                  break;
                }
                index++;
              }
            }
          }
        }
      } else {
        this.userCategories.push(category.id);
      }
    } else if (category.name === "All" && !evento.checked) {
      for (let itemCat of this.allCategories) {
        if (this.isAdded(itemCat.id) && itemCat.father === category.father) {
          let index = 0;
          for (let i of this.userCategories) {
            if (itemCat.id === i) {
              this.userCategories.splice(index, 1);
              break;
            }
            index++;
          }
        }
      }
    } else if (category.name === "All" && evento.checked) {
      for (let itemCat of this.allCategories) {
        if (!this.isAdded(itemCat.id) && itemCat.father === category.father) {
          this.userCategories.push(itemCat.id);
        }
      }
    }

    console.log(this.userCategories);
  }

  isCheked(category) {
    if (category.name === "All") {
      return this.checkAll(category);
    } else {
      return this.isAdded(category.id);
    }
  }

  checkAll(category) {
    for (let item of this.categories) {
      if (item.id === category.father) {
        for (let i of item.sub) {
          if (!this.isAdded(i.id)) {
            return false;
          }
        }
        return true;
      }
    }
  }

  isAdded(id) {
    for (let i of this.userCategories) {
      if (id === i) {
        return true;
      }
    }
    return false;
  }

  ngOnInit() {
    console.log("holaaqi");

    if (this.identity == null && this.identity.sub) {
      this._router.navigate(["/pages/lock"]);
    }
    this.myControlCountries.disable();
    this.myControlStates.disable();
    this.getCountries();
  }

  openNuevoCompany(): void {
    this.company = new CompanyLinked(
      1,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      1,
      0,
      "",
      "",
      "",
      "",
      "",
      0,
      0,
      0,
      0
    );
    let dialogRef = this.dialog.open(NuevoCompany, {
      width: "80%",
      data: { user: this.company },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      this._companylinkedService.create(this.token, result).subscribe(
        (response) => {
          console.log(response);
          this.status_user = response.status;

          if (this.status_user != "success") {
            this.status_user = "error";
          } else {
            this.getAllCompanies();
            this.companySelected = response.company.id;
            this.data.user.companyLinked = {
              id: this.companySelected,
            };
          }
        },
        (error) => {
          this.mtds.notifyError(error.statusText, error.status);
          console.log(<any>error);
        }
      );
    });
  }

  public loadingCountries = false;
  public loadingStates = false;

  displayCountry(country: any): string {
    return country?.name || "";
  }

  displayState(state: any): string {
    return state ? `${state.abbr} - ${state.name}` : "";
  }
  onStateSelected(state: any) {
    console.log("stateee", state);
    this.data.user.colonia = state.abbr;
  }
  getCountries(triggerAutocompleteFromBlank = false) {
    this._taxService.getCountries().subscribe((r) => {
      this.loadingCountries = true;
      if (r.status == "success") {
        this.loadingCountries = false;
        this.countries = r.data;

        this.filteredCountries = this.myControlCountries.valueChanges.pipe(
          startWith<string | UserList>(""),
          map((value) =>
            typeof value === "string" ? value : value?.name ?? ""
          ),
          map((name) =>
            name ? this._filterCountries(name) : this.countries.slice()
          )
        );

        // Si fue llamado desde "blank"
        if (triggerAutocompleteFromBlank) {
          this.myControlCountries.enable();
          this.myControlStates.enable();
          this.myControlCountries.setValue("");
          this.myControlStates.setValue("");
        }

        // Si viene ya con un país seteado
        if (this.data.user) {
          const foundCountry = this.countries.find(
            (c) => c.name === this.formatName(this.data.user.country)
          );
          if (foundCountry) {
            this.myControlCountries.setValue(foundCountry);
            this.getStates(foundCountry?.name);
          }
        }
      }
    });
  }
  onCountrySelected(country: any) {
    this.data.user.country = country.name;
    console.log("País seleccionado:", country);
    this.getStates(this.data.user.country);
  }
  getStates(countryName) {
    console.log("countryname", countryName);
    let country_id = null;
    for (let country of this.countries) {
      if (country.name == countryName) {
        country_id = country.id;
        break;
      }
    }
    console.log("country id", country_id);
    this._taxService.showAll(country_id).subscribe(
      (r) => {
        console.log(r.data, "states");
        this.states = r.data;
        const coloniaAbbr = this.data.user.colonia?.split(" - ")[0]; // Extrae sólo "TX"
        const foundState = this.states.find((c) => c.abbr === coloniaAbbr);

        this.filteredStates = this.myControlStates.valueChanges.pipe(
          startWith<string | UserList>(""),
          map((value) => (typeof value === "string" ? value : value.name)),
          map((name) => (name ? this._filterStates(name) : this.states.slice()))
        );
        if (foundState) {
          this.myControlStates.setValue(foundState);
        }
        console.log("jala los states", this.states);
        this.loadingStates = false;
      },
      (error) => {
        this.loadingStates = false;
      }
    );
  }
  formatName(name: string): string {
    if (!name) return "";
    return name
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  getCompanyLocations(company_id) {
    this._locationService
      .getLocationsByCompany(this.token, company_id)
      .subscribe((r) => {
        console.log(r);
        this.companyLocations = r.data;
      });
  }

  changeLocation() {
    if (this.data.user.locationId === "null") {
      this.data.user.locationId = null;
    }
    this.getCountries(); // <-- pasamos bandera opcional

    this.data.user.typeLocationSelected = "Headquarter";
    this.myControlCountries.disable();
    this.myControlStates.disable();

    let flat = false;

    if (this.data.user.locationId != null && this.data.user.locationId != 0) {
      for (let loc of this.companyLocations) {
        if (this.data.user.locationId == loc.id) {
          this.myControlCountries.disable();
          this.myControlStates.disable();
          this.myControlCountries.setValue(loc.country);
          this.myControlStates.setValue(loc.colonia);
          this.data.user.address = loc.address;
          this.data.user.address2 = loc.address2;
          this.data.user.country = loc.country;
          this.data.user.colonia = loc.colonia;
          this.data.user.city = loc.city;
          this.data.user.zipCode = loc.zipCode;
          this.data.user.phone = loc.phone;
          flat = true;
          break;
        }
      }
      this.data.user.typeLocationSelected = "Location";
    } else if (this.data.user.locationId == 0) {
      // Primero limpiar datos
      this.data.user.typeLocationSelected = "Blank";
      this.data.user.address = "";
      this.data.user.address2 = "";
      this.data.user.country = "";
      this.data.user.colonia = "";
      this.data.user.city = "";
      this.data.user.zipCode = "";
      this.myControlCountries.setValue("");
      this.myControlStates.setValue("");
      // Luego obtener países y activar autocomplete
      this.getCountries(); // <-- pasamos bandera opcional

      flat = true;
    }

    if (!flat && this.companyLinked) {
      this.data.user.address = this.companyLinked.address;
      this.data.user.address2 = this.companyLinked.address2;
      this.data.user.country = this.companyLinked.country;
      this.data.user.colonia = this.companyLinked.colonia;
      this.data.user.city = this.companyLinked.city;
      this.data.user.zipCode = this.companyLinked.zipCode;
      this.data.user.phone = this.companyLinked.phone;
      this.myControlCountries.setValue(this.companyLinked.country);
      this.myControlStates.setValue(this.companyLinked.colonia);
    }
  }

  changeCompany(e) {
    console.log("holi", e);
    if (e.value) {
      this.companySelected = e.value;

      this.data.user.companyLinked = {
        id: this.companySelected,
      };
      console.log(this.data.user.companyLinked);
      this._companylinkedService
        .getCompany(this.token, this.companySelected)
        .subscribe(
          (response) => {
            console.log(response.data);
            this.companySelected = response.data.name;
            this.companyName = response.data.name;

            this.data.user.address = response.data.address;
            this.data.user.address2 = response.data.address2;
            this.data.user.city = response.data.city;
            this.data.user.colonia = response.data.colonia;
            this.data.user.zipCode = response.data.zipCode;
            this.data.user.country = response.data.country;
            this.data.user.phone = response.data.phone;
            this.data.user.mobilePhone = response.data.mobilePhone;
            this.myControlCountries.setValue(response.data.country);
            this.myControlStates.setValue(response.data.colonia);
            this.getCountries();

            this.companyLinked = response.data;
            // this.data.user.locationId = null;
            this.getCompanyLocations(this.companyLinked.id);
          },
          (error) => {
            this.mtds.notifyError(error.statusText, error.status);
            console.log(<any>error);
          }
        );
    }
  }

  closeModal() {
    console.log("");
    let respuesta;
    return (respuesta = {
      usuario: this.data.user,
      categories: this.userCategories,
    });
  }
}
